import { useEffect } from 'react';
import '../css/AdminPageModal.css';

function AdminPageModal({ title, url, onClose }) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const closeOnEscape = event => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', closeOnEscape);
    };
  }, [onClose]);

  return <div className="admin-page-modal-backdrop" role="presentation"><section className="admin-page-modal" role="dialog" aria-modal="true" aria-label={title}><header><strong>{title}</strong><button type="button" onClick={onClose}>✕ ปิด</button></header><iframe title={title} src={url} /></section></div>;
}

export default AdminPageModal;
